import React from 'react';
import { Document, Page, View, StyleSheet } from '@react-pdf/renderer';
import PDFTable from './PDFTable';
import PDFHeader from './PDFHeader';
import { PDF_UNICODE_FONT, registerPdfUnicodeFont } from './registerPdfUnicodeFont';

registerPdfUnicodeFont();

const styles = StyleSheet.create({
    page: {
        paddingTop: 28,
        paddingBottom: 36,
        paddingHorizontal: 28,
        boxSizing: 'border-box',
        fontFamily: PDF_UNICODE_FONT,
    },
    heading: {
        fontSize: 20,
        fontWeight: "bold",
        marginBottom: 10,
        textAlign: "center",
    },
    logo: {
        width: '20%',
        padding: 10,
    },
});



const Mypdf = ({ tableData, tableHeaders, heading, companyData = {} }) => {
    // Add safety checks for required props
    const safeTableData = Array.isArray(tableData) ? tableData : [];
    const safeTableHeaders = Array.isArray(tableHeaders) ? tableHeaders : [];
    const safeHeading = heading || "Report";
    const safeCompanyData = companyData || {};

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <PDFHeader companyData={safeCompanyData} />
                <View>
                    <PDFTable
                        tableHeaders={safeTableHeaders}
                        data={safeTableData}
                        heading={safeHeading}
                    />
                </View>
            </Page>
        </Document>
    );
};

export default Mypdf;
